export enum ControlsType {
  OrbitControls = 'OrbitControls',
  FirstPersonControls = 'FirstPersonControls'
}
